<template>
  <div class="flex-container">
    <div class="menubar flex-100">
      <span class="title">Wat is de doelstelling van uw klant?</span>
    </div>

    <div
      v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
      class="flex-33 card option"
      @click="selectGoal('pensioen', '1')"
      style="height: 200px;"
    >
      <h2>Lijfrente opbouwen (box{{'\xa0'}}1)</h2>
      <p>
        Dit is voor de klant die gaat starten met het opbouwen middels jaar- en
        reserveringsruimte.
      </p>
    </div>

    <div
      v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
      class="flex-33 card option"
      @click="selectGoal('pensioen', '1')"
      style="height: 200px;"
    >
      <h2>Lijfrente uitstellen (box{{'\xa0'}}1)</h2>
      <p>
        Dit is voor de klant waar een kapitaal vrijkomt, maar die nog wil wachten met het
        uitkeren. In de tussentijd kan er al belegd worden.
      </p>
    </div>

    <div
      v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
      class="flex-33 card option"
      @click="selectGoal('levensonderhoud', '1')"
      style="height: 200px;"
    >
      <h2>Lijfrente uitkeren (box{{'\xa0'}}1)</h2>
      <p>
        Dit is voor de klant die een kapitaal beschikbaar heeft en direct wil starten met
        uitkeren.
      </p>
    </div>

    <div
      class="flex-33 card option"
      @click="selectGoal('netto-lijfrente-opbouwend', '1')"
      style="height: 200px;"
    >
      <h2>
        Netto lijfrente</h2>
      <p>
        Dit is voor de klant die naast de jaarruimte nog meer wil opbouwen. (voor inkomens
        boven de &euro; 115.000)
      </p>
    </div>

    <div
      class="flex-33 card option"
      @click="selectGoal('gouden-handdruk-opbouwend', '1')"
      style="height: 200px;"
    >
      <h2>Gouden handdruk uitstellen</h2>
      <p>
        Dit is voor de klant met vrij GH-kapitaal, maar die nog wil wachten.
        In de tussentijd kan er al belegd worden.
      </p>
    </div>

    <div
      class="flex-33 card option"
      @click="selectGoal('gouden-handdruk-uitkerend', '1')"
      style="height: 200px;"
    >
      <h2>Gouden handdruk uitkeren</h2>
      <p>
        Dit is voor de klant die een GH kapitaal beschikbaar heeft en direct wil starten met
        uitkeren.
      </p>
    </div>

    <div
      class="flex-33 card option"
      @click="selectGoal('vermogensopbouw')"
      style="height: 200px;"
    >
      <h2>Privé beleggingsrekening</h2>
    </div>

    <div
      class="flex-33 card option"
      @click="selectGoal('zakelijke-vermogensopbouw')"
      style="height: 200px;"
    >
      <h2>Zakelijke beleggingsrekening</h2>
    </div>

    <div
      class="flex-33 card option"
      @click="selectGoal('studiekinderen')"
      style="height: 200px;"
    >
      <h2>Beleggingsrekening voor kinderen</h2>
    </div>

  </div>
</template>

<script>
export default {
  name: 'IntakeAtpGoalSelectPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  methods: {
    selectGoal(goal, box = '3') {
      this.modelValue.goalData.type = goal;
      this.modelValue.goalData.box = box;
      this.modelValue.goalData.step = 2;
      delete this.modelValue.goalData.targetDate;
      if (goal === 'studiekinderen') {
        this.modelValue.rekeningData.type = 'Minderjarige rekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Volmacht';
        this.modelValue.persoonsData.push({ type: 'Minderjarige' });
      } else if (goal === 'zakelijke-vermogensopbouw') {
        this.modelValue.goalData.type = 'vermogensopbouw';
        this.modelValue.rekeningData.type = 'Bedrijfsrekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = '';
      } else {
        this.modelValue.rekeningData.type = 'Particuliere rekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Rekeninghouder';
      }
      // Clearing data upon changing goal
      for (let i = 0; i < this.$parent.intake.persoonsData.length; i += 1) {
        if (this.$parent.intake.goalData.box === '1') {
          delete this.$parent.intake.persoonsData[i].herkomstVermogenSalaris;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenErfenis;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenSchenking;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenWoningverkoop;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenBedrijfsverkoop;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenBox1lijfrente;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenBox3lijfrente;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenGoudenhanddruk;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenCryptovaluta;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenAnders;
          this.$parent.intake.persoonsData[i].woningVerkoopPostcode = '';
          this.$parent.intake.persoonsData[i].woningVerkoopHuisnummer = '';
          this.$parent.intake.persoonsData[i].woningVerkoopToevoeging = '';
        }
      }
      if (this.$parent.intake.goalData.box === '3') {
        this.$parent.intake.transferData.overdrachten = [];
      }
      this.$parent.setDefaults();
    },
  },
};
</script>

<style lang="scss" scoped>
  .flex-container {
    column-gap: 20px;
    row-gap: 20px;
    @media #{$mobile} {
      row-gap: 10px;
      padding: 43px 10px 10px;
    }
  }
  @media #{$mobile} {
    #firstMenubar {
      top: 91px !important;
    }
  }
</style>
